import React from 'react';
import Axios from "axios";
import {serverUrl} from './constants'


class CsvResponse extends React.Component{
    constructor(props) {
        super(props);
        this.link = React.createRef();

        this.handleRequest = this.handleRequest.bind(this);
    }

    handleRequest(){
        if(this.link.current.href)
        {
            return;
        }
        Axios.get(serverUrl + '/api/zip',
            {
                responseType: 'blob',
                timeout : 30000,
            }
        ).then(result => {
            const href =  window.URL.createObjectURL(result.data);
            this.link.current.download = "csv_files.zip"
            this.link.current.href = href;
            this.link.current.click();
        });
    }

    render(){
        return (
            <div id="wrap">
                <>
                    <a id="content" className="button" role='button' ref={this.link} onClick={this.handleRequest}>Download as CSV</a>
                </>
            </div>
        )
    }
}

export default CsvResponse;